import { AuthenticatedLayout } from '@client/components/_core/layout/AuthenticatedLayout';
import { PageController } from '@client/components/_core/layout/PageController';
import { RequireAuth } from '@client/components/auth/RequireAuth';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Home } from 'lucide-react';

export const Route = createFileRoute('/admin-console')({
    staticData: {
        ui: {
            icon: Home,
        },
    },
    component: AdminConsole,
});

function AdminConsole() {
    return (
        <PageController route={Route}>
            <RequireAuth>
                <AuthenticatedLayout>
                    <Outlet />
                </AuthenticatedLayout>
            </RequireAuth>
        </PageController>
    );
}
